import React from "react";
import styled from "styled-components";
import { Container, media } from "styled-bootstrap-grid";
import SectionHeader from "../../common/Header/SectionHeader";
import {
  StaticImage,
  GatsbyImage,
  GatsbyImageProps,
} from "gatsby-plugin-image";
import { LightButton, YellowButton } from "./DealerForm";
import { DEALER_DATA } from "./defaultDealer";
import { DatoDealer, Dealer } from "../../../types";

type DearlerDetailProps = {
  datoDealer: DatoDealer;
  dealer: Dealer;
};

type ImageProps = {
  gatsbyImageData: GatsbyImageProps["image"];
};

const ImageContainer = styled.div`
  max-height: 100%;
  min-width: 350px;
  width: 40%;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
  }
`;

const DealerContent = styled.div`
  display: flex;
  align-items: center;
  color: #00005;
  margin-top: 50px;
  width: 100%;

  margin: 20px 0;
  font-size: 24px;
  font-family: "DIN2014";

  ${media.lg`
    width: 60%;
  `}
`;

const ValueContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${media.lg`
    flex-direction: row;
  `}
`;

const StyledContainer = styled(Container)`
  margin-top: 50px;

  > div:nth-child(2) {
    ${ValueContainer} {
      flex-direction: column-reverse;

      ${media.lg`
        flex-direction: row-reverse;
      `}
    }
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
`;

const StyledExternalLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-size: inherit;
`;

const DealerValues: React.FC<DearlerDetailProps> = ({ dealer, datoDealer }) => {
  const enquiryScroll = () => {
    const formEl = document.querySelector("#dealer-form");
    //@ts-ignore
    formEl.scrollIntoView({ behavior: "smooth" });
  };

  const callPhone = () => {
    //@ts-ignore
    if (Array.isArray(window.dataLayer)) {
      //@ts-ignore
      window.dataLayer.push({
        event: "call_dealer_from_website",
        storeId: dealer.id,
        dealerName: dealer.name,
      });
    }
  };

  const dealerPhone = dealer?.phone
    ? dealer.phone
    : datoDealer?.phone
    ? datoDealer?.phone
    : "";

  return (
    <>
      <StyledContainer>
        <>
          {datoDealer &&
          Array.isArray(datoDealer.articles) &&
          datoDealer.articles.length > 0 ? (
            datoDealer.articles.map((item) => (
              <div>
                <SectionHeader>{item.header}</SectionHeader>
                <ValueContainer>
                  <DealerContent>{item.description}</DealerContent>
                  <ImageContainer>
                    {item.image ? (
                      <GatsbyImage
                        image={(item.image as ImageProps)?.gatsbyImageData}
                        alt="dealer-product"
                      />
                    ) : (
                      <StaticImage
                        src="../../../images/roylances-logo.png"
                        alt="logo"
                        width={318}
                        placeholder="blurred"
                        layout="fixed"
                      />
                    )}
                  </ImageContainer>
                </ValueContainer>
              </div>
            ))
          ) : (
            <div>
              <SectionHeader>{DEALER_DATA.articles[0].header}</SectionHeader>
              <ValueContainer>
                <DealerContent>
                  {DEALER_DATA.articles[0].description}
                </DealerContent>
                <ImageContainer>
                  <StaticImage
                    src="../../../images/HP12150DE.jpg"
                    alt="logo"
                    width={318}
                    placeholder="blurred"
                    layout="fixed"
                  />
                </ImageContainer>
              </ValueContainer>
            </div>
          )}
        </>
      </StyledContainer>
      <ButtonContainer>
        <LightButton onClick={() => enquiryScroll()}>Enquire now</LightButton>
        <YellowButton onClick={callPhone}>
          <StyledExternalLink href={`tel: ${dealerPhone}`}>
            Call now
          </StyledExternalLink>
        </YellowButton>
      </ButtonContainer>
    </>
  );
};

export default DealerValues;
